import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function getEntityDefaultValue(params) {
  return request({
    url: URL.sys.defaultValueManage,
    method: 'get',
    params
  })
}

// 加载默认值配置列表
export function loadJobDefaultValues(params) {
  return request({
    url: URL.sys.loadJobDefaultValues,
    method: 'get',
    params
  })
}

// 保存默认值配置
export function saveEntityDefaultValue(data) {
  return request({
    url: URL.sys.saveEntityDefaultValue,
    method: 'post',
    data
  })
}

export function addEntityDefaultValue(branchId, data) {
  return request({
    url: `${URL.sys.defaultValueManage}/${branchId}`,
    method: 'post',
    data
  })
}

export function updateEntityDefaultValue(data) {
  return request({
    url: URL.sys.defaultValueManage,
    method: 'put',
    data
  })
}

export function batchDelEntityDefaultValue(uuids) {
  const data = [...uuids]
  return request({
    url: URL.sys.defaultValueManageBatchDel,
    method: 'delete',
    data
  })
}

// 默认值管理-列表选择业务实体
export function getDefaultValueEntity4List() {
  return request({
    url: URL.sys.defaultValueManageEntityList,
    method: 'get'
  })
}

// 默认值管理-新增弹窗根据branchId选择业务实体
export function getDefaultValueEntity4Add(branchId) {
  return request({
    url: URL.sys.defaultValueManageEntityAdd,
    method: 'get',
    params: { branchId }
  })
}
// 获取全部tenant
export function getAllTenant() {
  return request({
    url: URL.sys.tenant,
    method: 'get'
  })
}
// 添加租户默认值
export function addEntityDefaultValueForTenant(branchId, data) {
  return request({
    url: `${URL.sys.addEntityDefaultValueForTenant}/${branchId}`,
    method: 'post',
    data
  })
}
// 平台维护添加默认值
export function addEntityDefaultValueForPlateForm(data) {
  return request({
    url: URL.sys.addEntityDefaultValueForPlateForm,
    method: 'put',
    data
  })
}
